import React from 'react';
import { Box, Card, CardContent, Typography, Chip, useTheme } from '@mui/material';
import { CheckCircle, Topic as TopicIcon } from '@mui/icons-material';
import { AnalysisSummaryProps } from '../types';

const AnalysisSummary: React.FC<AnalysisSummaryProps> = ({ topicsCount, workflowId }) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          flexWrap: 'wrap'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 0 } }}>
            <CheckCircle color="success" sx={{ mr: 1 }} />
            <Typography variant="h6" component="div">
              Analysis Complete
            </Typography>
            <Chip 
              label={`${topicsCount} Topics`}
              color="primary"
              size="small"
              icon={<TopicIcon fontSize="small" />}
              sx={{ ml: 2 }}
            />
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            <strong>Workflow:</strong> {workflowId}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AnalysisSummary;
